module.exports = __webpack_public_path__ + "96eac06e9ae7c7ba58edf55ab177cd5a.pdf";